/*
 * @Author: bbqin
 * @Date: 2023-05-16 18:12:26
 * @LastEditTime: 2023-05-17 14:09:01
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\Form\components\container\FormCardContainer.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React, { Component } from 'react';
import { isJSON, getMultiLang } from '@platform/api';
import FormCard from './FormCard';
import { isFirstDayOfMonth } from 'date-fns';
require('../../formCard.less');
const defaultProps = {
    grid: 16,
    visible: true,
    value: '',
    title: '',
    icon: '',
};

const containerPath = 'LowCodeComponents.NCFormCardContainer';
const cardPath = 'LowCodeComponents.NCFormCard';

class FormCardContainer extends Component {
    constructor(props) {
        super(props);
        this.state = { langJson: {} };
    }

    UNSAFE_componentWillMount() {
        // 初始化多语加载 
        getMultiLang({
            moduleId: "page_form",
            callback: json=>{
                this.setState({ langJson: json });
            },
        });
    }
    
    render() {
        // showContainer 是否显示关键信息区，新加的交互，关键信息区和表单互斥，只显示一个
        let { cardContainerId, coregroups = [] } = this.props;
        
        // if(!showContainer) return null;
        if(coregroups.length){
            return this.renderCardFromProps(coregroups);
        }else if (cardContainerId) {
            // 表单根据关联关系读取到的关键信息区id
            cardContainerId = Array.isArray(cardContainerId) ? cardContainerId : [cardContainerId];
            return this.renderCardContainer(cardContainerId);
        } else {
            // 没有关联关系，从layout读取需要渲染的关键信息区
            return this.renderCardContainer();
        }
    }

    renderCardContainer = cardContainerIds => {
        let { store, visible = true, grid = 16, layout, meta, pageScope, pageId, showContainer } = this.props;
        // 通过 createFormCard API创建的 关键信息区卡片没有layout 需要从meta里去读
        if (!meta) {
            const { getHotKeyConfig = () => { } } = this.props;
            let { meta: newMeta = {} } = getHotKeyConfig() || {};
            meta = newMeta;
        }
        if (!layout) {
            let { layout: newLayout = '[]' } = meta;
            layout = isJSON(newLayout) ? JSON.parse(newLayout) : [];
        }
        let cardContainerIdArr = [];
        // 获取到需要渲染的关键信息区
        if (cardContainerIds) {
            cardContainerIds.forEach(cardContainerId => {
                let cardContainerIdArray = layout.filter(item => item?.props?.moduleId === cardContainerId && item.path === containerPath);
                cardContainerIdArr = cardContainerIdArr.concat(cardContainerIdArray);
            });
        } else {
            cardContainerIdArr = layout.filter(item => item.path === containerPath);
        }
        return cardContainerIdArr.map(cardContainerIdItem => {
            // 根据表单编辑状态和组件属性共同决定
            let { visible: cardContainerVisible = true } = this.getAreaProps(cardContainerIdItem.props.moduleId, layout) || {};
            // 从 layout 读取 opposite 属性 表单和关键信息区显示隐藏互斥（true） 另一种是表单和关键信息区显示隐藏没关系（false）
            let { opposite = true } = this.getAreaProps(cardContainerIdItem.props.moduleId, layout) || {};
            let renderVisible = visible && cardContainerVisible;
            if (!renderVisible) {
                return null;
            }
            if(opposite && showContainer || !opposite){
                // 根据layout获取关联的关键信息卡片
                let renderCardArray = layout.filter(item => item.parentId === cardContainerIdItem.$id && item.path === cardPath && item?.props?.visible !== false);
                let DOM = [];
                renderCardArray.forEach(cardId => {
                    let props = this.getAreaProps(cardId.props.moduleId, layout);
                    DOM.push(<FormCard store={store} layout={layout} meta={meta} pageId={pageId} pageScope={pageScope} langJson={this.state.langJson} {...props}></FormCard>);
                });
                return <div key={cardContainerIdItem.$id} className="form-card-wrapper-container">
                    {DOM}
                </div>;
            }
        });
    }

    renderCardFromProps = coregroups => {
        let { store, visible = true, grid = 16, layout, meta, pageScope, showContainer, opposite } = this.props;
        // 通过 createFormCard API创建的 关键信息区卡片没有layout 需要从meta里去读
        if (!meta) {
            const { getHotKeyConfig = () => { } } = this.props;
            let { meta: newMeta = {} } = getHotKeyConfig() || {};
            meta = newMeta;
        }
        let DOM = [];
        coregroups.forEach(card => {
            DOM.push(<FormCard store={store} meta={meta} pageScope={pageScope} langJson={this.state.langJson} {...card}></FormCard>);
        });
      
        return (opposite && showContainer || !opposite) ? <div className="form-card-wrapper-container">
            {DOM}
        </div> : null;

    }

    // 从 layout 读取当前当前区域的 props
    getAreaProps = (item, layout) => {
        let currentArea = layout.find(element => element.props.moduleId === item);
        return currentArea?.props;
    }

}

FormCardContainer.defaultProps = defaultProps;
FormCardContainer.displayName = 'FormCardContainer';
export default FormCardContainer;